import api from '@/api/index.js'

const offline_filters = {
  state: {
    loading: false,
    data: [],
    error: null
  },

  mutations: {
    SET_OFFLINE_FILTERS_LOADING: (state, loading) => {
      state.loading = loading
    },
    SET_OFFLINE_FILTERS: (state, response) => {
      state.data = response
      state.loading = false
    },
    SET_OFFLINE_FILTERS_ERROR: (state, error) => {
      state.error = error
    },
    SET_OFFLINE_FILTERS_FILTER_DETAILS: (state, filterDetails) => {
      state.filterDetails = filterDetails
    }
  },

  actions: {
    LoadOfflineFilters({commit}, query) {
      commit('SET_OFFLINE_FILTERS', [])
      commit('SET_OFFLINE_FILTERS_ERROR', null)
      commit('SET_OFFLINE_FILTERS_LOADING', true)
      return api.get(`bloom-filters?limit=150&offset=0`)
        .then((response) => {
          commit('SET_OFFLINE_FILTERS', response)
        })
        .catch((error) => {
          commit('SET_OFFLINE_FILTERS_ERROR', error.bodyText == '' ? error.url + ' - ' + error.status : error.bodyText)
          commit('SET_OFFLINE_FILTERS_LOADING', false)
          commit('SET_ERROR', error.bodyText == '' ? error.url + ' - ' + error.status : error.bodyText)
        })
    },
  }
}

export default offline_filters
